import gql from 'graphql-tag';

export const resetSaveViewMutation = gql`
  mutation resetSaveView($input: UserSaveViewInput!) {
    saveView(input: $input) {
      status
      userViewState
    }
  }
`;
